import { render, staticRenderFns } from "./DialogViewDetail.vue?vue&type=template&id=667819ff&scoped=true"
import script from "./DialogViewDetail.vue?vue&type=script&lang=js"
export * from "./DialogViewDetail.vue?vue&type=script&lang=js"
import style0 from "./DialogViewDetail.vue?vue&type=style&index=0&id=667819ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667819ff",
  null
  
)

export default component.exports